export const config = {

  APPID: 2017091908809974,
  testUrl: "http://101.132.238.119:8976",

  serverBaseUrl1: 'https://api.id-photo-verify.com',

  serverBaseUrl2: 'https://apicall.id-photo-verify.com',
  serverBaseUrl3: 'https://uniform.91pitu.com',
  // serverBaseUrl3: 'https://leqi.zhgroot.cn/wechat',
  printUrl: 'https://suqin.prd.91pitu.com',
  // printUrl: 'https://suqin.tst.91pitu.com',
  // serverBaseUrl3: 'http://101.132.238.119:8075',
  serverBaseUrl4: 'http://101.132.238.119:8546',
  oAuthDomain: 'https://a.id-photo-verify.com',
  mockurl: 'http://101.132.238.119:8067',

  get getPhotoBaseUrl() {
    return `${this.serverBaseUrl2}/alipay/take_pic_alipay/`;
  },

  get oAuthUrl() {
    return `${this.serverBaseUrl2}/alipay/begin_get_user_id`;
  }
};